export default "__VITE_ASSET__DAJXsjqQ__"